module.exports = __webpack_public_path__ + "img/cv.b8dfff2b.png";